import { render, staticRenderFns } from "./CustomAttribute.vue?vue&type=template&id=481fa364&scoped=true"
import script from "./CustomAttribute.vue?vue&type=script&lang=js"
export * from "./CustomAttribute.vue?vue&type=script&lang=js"
import style0 from "./CustomAttribute.vue?vue&type=style&index=0&id=481fa364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481fa364",
  null
  
)

export default component.exports